export default __webpack_public_path__ + "static/media/G.b8aea4a6.svg";